import { configureStore } from '@reduxjs/toolkit';
import siteReducer from "./slices/sitesSlice";

export const store = configureStore({
  reducer: {
    sites:siteReducer
  },
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;